export const SET_SHOW_PAGE_COLLAPSING_HEADER =
  'pageCollapsingHeader/SET_SHOW_PAGE_COLLAPSING_HEADER';
export const SET_IS_SUB_MENU_DROPDOWN_CONTENT =
  'pageCollapsingHeader/SET_IS_SUB_MENU_DROPDOWN_CONTENT';
